"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFloatingBehaviorOperatorSet = isFloatingBehaviorOperatorSet;
exports.modelFloatingBehavior = modelFloatingBehavior;
exports.resolveFormFloatingBehavior = resolveFormFloatingBehavior;
exports.recoverFloatingBehaviorChoice = recoverFloatingBehaviorChoice;
exports.buildCanonicalSignalFromModelSignal = buildCanonicalSignalFromModelSignal;
exports.buildUnboundCanonicalSignal = buildUnboundCanonicalSignal;
exports.floatingBehaviorField = floatingBehaviorField;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function isFloatingBehaviorOperatorSet(modelSignal) {
    return modelSignal === undefined || modelSignal.isOptional;
}
function modelFloatingBehavior(modelSignal) {
    return modelSignal.floatingBehavior ?? sigma_engine_shared_1.DesignModels.SignalFloatingBehavior.Never;
}
function resolveFormFloatingBehavior(modelSignal, choice) {
    if (choice !== undefined || modelSignal === undefined || isFloatingBehaviorOperatorSet(modelSignal)) {
        return choice;
    }
    return modelFloatingBehavior(modelSignal);
}
function recoverFloatingBehaviorChoice(modelSignal, stored) {
    const unchosen = modelSignal === undefined || isFloatingBehaviorOperatorSet(modelSignal) ?
        sigma_engine_shared_1.DesignModels.SignalFloatingBehavior.Unspecified
        : modelFloatingBehavior(modelSignal);
    return stored === unchosen ? undefined : stored;
}
function buildCanonicalSignalFromModelSignal(modelSignal, overrides = {}) {
    return {
        id: overrides.id ?? modelSignal.id,
        name: overrides.name ?? modelSignal.name,
        padRefs: [],
        pinRefs: [],
        signalDirection: modelSignal.direction ?? undefined,
        attributes: { ...modelSignal.attributes },
        description: modelSignal.description ?? undefined,
        modelSignal: modelSignal.id,
        blockInfo: overrides.blockInfo,
        ...floatingBehaviorField(resolveFormFloatingBehavior(modelSignal, overrides.floatingBehavior)),
        supportedDriveModes: [],
        ties: [],
        isCadstromInternal: false,
    };
}
function buildUnboundCanonicalSignal(args) {
    return {
        id: args.id,
        name: args.name,
        padRefs: [],
        pinRefs: [],
        attributes: {},
        ...(args.blockInfo !== undefined ? { blockInfo: args.blockInfo } : {}),
        ...floatingBehaviorField(args.floatingBehavior),
        supportedDriveModes: [],
        ties: [],
        isCadstromInternal: false,
    };
}
function floatingBehaviorField(floatingBehavior) {
    return floatingBehavior !== undefined ? { floatingBehavior } : {};
}
//# sourceMappingURL=form-model-shape.js.map